import * as queryKeys from "@/data/constant/queryKeys";
import { TerminalType } from "@/types/terminal.type";
import { request } from "@/util/api";
import { useQuery } from "@tanstack/react-query";

const useTerminalData = (search?: any, enabled?: boolean) => {
  return useQuery<TerminalType[]>({
    queryKey: [queryKeys.TERMINAL_DATA, search],
    queryFn: () =>
      request({
        method: "GET",
        url: `/terminal`,
        params: search,
      }),
    enabled: enabled,
  });
};

export default useTerminalData;
